import ky, { type HTTPError } from "ky";
import { fetchCsrfToken, clearCsrfCache } from "@/lib/auth";
import type { ApiError } from "@/lib/errors";

const commonOptions = {
  credentials: "include" as const,
  hooks: {
    beforeRequest: [
      async (request: Request) => {
        const method = request.method.toUpperCase();
        if (["POST", "PUT", "DELETE", "PATCH"].includes(method)) {
          // Token is fetched from /dashboard/auth/csrf on first call and
          // cached in memory — never read from a cookie.
          request.headers.set("X-CSRF-Token", await fetchCsrfToken());
        }
      },
    ],
    beforeError: [
      async (error: HTTPError) => {
        // ky's message is only "Request failed with status code …". The
        // server's own message is in the body: kept here for toUserMessage
        // (lib/errors.ts), which falls back when it isn't the API's JSON.
        try {
          (error as ApiError).responseBody = await error.response.clone().text();
        } catch {
          // no body to keep
        }
        return error;
      },
    ],
    afterResponse: [
      async (_request: Request, _options: unknown, response: Response) => {
        if (response.status === 401) {
          clearCsrfCache(); // force a fresh token fetch on next login
          window.location.href = "/login";
        }
      },
    ],
  },
};

export const api = ky.create({
  prefixUrl: "/dashboard/api",
  ...commonOptions,
});

// Customer-facing billing endpoints live under /api/billing/* (separate router).
export const billingApi = ky.create({
  prefixUrl: "/api/billing",
  ...commonOptions,
});
